<template>
    <div>
        Your EMR data tabs are empty. Please contact your clinic administrator to set security level so you could view the clinic's data.
    </div>
</template>

<script>
export default {
  name: 'PateNotFound',
  data () {
    return {}
  },
  mounted () {
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>

</style>
